module.exports = __webpack_public_path__ + "static/img/information_bg.112e010.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/information_bg.png
// module id = BDRA
// module chunks = 44